import { MdxDiv } from '@features/mdx/MdxDiv';
import { LanguageEnum } from '@project-types/LanguageEnum';
import { MdxPageArticleIds } from '@features/mdx/MdxPageArticleIds';



const articleIds: MdxPageArticleIds = {
	[LanguageEnum.CZ]: '07a62706-ed1e-4da8-b5c6-8d1fcef5e424',
	[LanguageEnum.SK]: '07a62706-ed1e-4da8-b5c6-8d1fcef5e424',
	default: '07a62706-ed1e-4da8-b5c6-8d1fcef5e424'
}


export const Infobox = () => {

	return (
		<MdxDiv className='info-box' articleIds={articleIds}>
		</MdxDiv>
	);
};